import { render, staticRenderFns } from "./historyCompliance.vue?vue&type=template&id=24ea7854&scoped=true&"
import script from "./historyCompliance.vue?vue&type=script&lang=js&"
export * from "./historyCompliance.vue?vue&type=script&lang=js&"
import style0 from "./historyCompliance.vue?vue&type=style&index=0&id=24ea7854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ea7854",
  null
  
)

export default component.exports